import { ResultCode } from "@lib/titan2/dist/api/common/controller/net/constant/Constants";
import { AbstractHandler } from "@lib/titan2/dist/api/core/handler/AbstractHandler";
import { EventHandler } from "@lib/titan2/dist/util/event/EventHandler";
import { GameRequest } from "./GameRequest";
import { GameResult } from "./GameResult";
/*
 * CurrentGameHandler.ts
 */
export class RequestHandler extends AbstractHandler {
    constructor(parameters, action, scope, requestURL, requestObj) {
        super();
        this.parameters = parameters;
        this.eventHandler = new EventHandler(action, scope);
        this.requestURL = requestURL;
        this.requestObj = requestObj;
    }
    destroy() {
        super.destroy();
        this.parameters = null;
        this.eventHandler = null;
    }
    run() {
        super.run();
        this.getCurrentGame();
    }
    getCurrentGame() {
        let request = new GameRequest(this.parameters, this.requestURL, this.requestObj);
        request.onSuccess(this.handleGetCurrentGameSuccess, this);
        request.onFailure(this.handleGetCurrentGameFailed, this);
        request.send();
    }
    handleGetCurrentGameSuccess(data) {
        this.handleAction(new GameResult(ResultCode.SUCCESS, data));
    }
    handleGetCurrentGameFailed(data) {
        this.handleAction(new GameResult(data.getResponseCode()));
    }
    handleAction(result) {
        this.eventHandler.call(result);
        this.destroy();
    }
}
//# sourceMappingURL=RequestHandler.js.map